import { fetchBeers, beerSlug } from './api';
import { renderBeerCard, showBeerOverlay } from './beer-card';
import { initAdmin, isAdminMode } from './admin';
import { Beer } from './types';

async function loadBeers(): Promise<Beer[]> {
  const grid = document.getElementById('beer-grid');
  if (!grid) return [];

  try {
    const beers = await fetchBeers();
    grid.innerHTML = '';
    beers.forEach((beer) => {
      const card = renderBeerCard(beer, loadBeers);
      grid.appendChild(card);
    });
    return beers;
  } catch (err) {
    grid.innerHTML = '<p class="error-text">Failed to load beers. Please try again later.</p>';
    return [];
  }
}

// /brews shows the list, /brews/<slug> opens that beer (QR codes on the bottles
// point here). A slug that no longer resolves falls back to the plain list.
function routeBeers(beers: Beer[]): void {
  if (!location.pathname.startsWith('/brews')) return;
  document.getElementById('beer')?.scrollIntoView();

  const slug = location.pathname.replace(/^\/brews\/?/, '').replace(/\/$/, '');
  if (!slug) return;

  const beer = beers.find((b) => beerSlug(b.name) === slug);
  if (beer) showBeerOverlay(beer, loadBeers);
  else history.replaceState(null, '', '/brews');
}

function initSmoothScroll(): void {
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const href = (link as HTMLAnchorElement).getAttribute('href');
      if (!href) return;
      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
}

function initContactForm(): void {
  const form = document.getElementById('contact-form') as HTMLFormElement | null;
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const name = (form.querySelector('[name="name"]') as HTMLInputElement).value;
    const message = (form.querySelector('[name="message"]') as HTMLTextAreaElement).value;
    const subject = encodeURIComponent(`Message from ${name} - Koz Brewery`);
    const body = encodeURIComponent(message);
    window.location.href = `mailto:kozyrevab@gmail.com?subject=${subject}&body=${body}`;
  });
}

function initNavToggle(): void {
  const toggle = document.getElementById('nav-toggle');
  const navLinks = document.getElementById('nav-links');
  if (!toggle || !navLinks) return;

  toggle.addEventListener('click', () => {
    navLinks.classList.toggle('nav-open');
    toggle.classList.toggle('active');
  });

  // Close mobile nav when a link is clicked
  navLinks.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      navLinks.classList.remove('nav-open');
      toggle.classList.remove('active');
    });
  });
}

document.addEventListener('DOMContentLoaded', async () => {
  initSmoothScroll();
  initContactForm();
  initNavToggle();
  initAdmin(loadBeers);
  routeBeers(await loadBeers());
});
